export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "";

export const KYC_API_KEY = process.env.REACT_APP_KYC_API_KEY ?? "";

export const KYC_DEFAULT_PROFILE_CODE = process.env.REACT_APP_KYC_DEFAULT_PROFILE_CODE ?? "";

export const SSO_API_BASE_URL = process.env.REACT_APP_SSO_API_BASE_URL ?? "";

// SSO token refresh endpoint (relative to SSO_API_BASE_URL).
export const SSO_REFRESH_TOKEN = "/v1.2/auth/refresh";
